module.exports = __webpack_public_path__ + "media/images/mao-912afaf27558b68b62197594c601445e.png";